module.exports = __webpack_public_path__ + "img/VNL.9920f229.svg";